module.exports = __webpack_public_path__ + "assets/img/14.b20737f2.png";